import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Modal, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import downloadExcel from "../../../../../services/downloadExcel";
import momentTZ from "moment-timezone";
import _ from "lodash";
class NewCarFinal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCar: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
      search: "",
    };
  }

  componentDidMount() {
    this.fetchNewCar(this.state.page, this.state.limit);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.status !== this.props.match.params.status) {
      this.setState({ isLoading: true, search: "", page: 1, limit: 15 }, () =>
        this.fetchNewCar(1, 15)
      );
    }
  }

  orderBy(sort) {
    let key = "date";
    let value = "DESC";

    //Get Key
    if (sort.name === "Car Type") key = "carName";
    else if (sort.name === "Kepala Cabang") key = "kacab";
    else if (sort.name === "Tanggal Selesai") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  getStatus() {
    let status = this.props.match.params.status;
    if (!["deal", "no-deal"].includes(status)) status = null;
    return status;
  }

  async fetchNewCar(page, limit) {
    const status = this.getStatus();
    const order = this.orderBy(this.state.sort);
    const query = `${order}&&page=${page}&&limit=${limit}&&search=${
      this.state.search || ""
    }`;
    const data = await axios
      .get(`admin-panel/new-car/${status}?${query}`)
      .then(result => {
        this.setState({
          newCar: result.data.ApprovalNewCar,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        message.error("Gagal request data new car");
        this.setState({ isLoading: false });
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchNewCar(page, limit);
  }

  formatRupiah(number) {
    const data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "No New Car",
        options: {
          sort: false,
        },
      },
      {
        name: "Car Type",
        options: {
          sort: true,
        },
      },
      {
        name: "Kepala Cabang",
        options: {
          sort: true,
        },
      },
      {
        name: "Cabang",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Selesai",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const newCar = this.state.newCar.map((item, idx) => {
      return [
        <Link
          to={{
            pathname: `/home/approval/new-car-final/${item.id}`,
            query: { status: this.props.match.params.status },
          }}>
          <Tooltip placement="bottom" title="Detail New Car">
            <Button icon="bars" style={{ marginRight: 10 }} />
          </Tooltip>
        </Link>,
        <Tag color={item.approvalStatus === "Deal" ? "green" : "magenta"}>
          {" "}
          {item.approvalStatus}{" "}
        </Tag>,
        item.noNewCar,
        item.NewCar.carName,
        item.SalesBranch.BranchHead.name,
        item.SalesBranch.branch,
        item.SalesBranch.area,
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
        }
      },
    };

    return (
      <Card
        title="List New Car Final"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        {/* <div style={{marginBottom: 10}}>
                    <Button onClick={() => this.downloadData()}>
                        Download Data
                    </Button>
                    
                    <Button onClick={() => this.openModal()} style={{ marginLeft: 10 }}>
                        Upload Data
                    </Button>
                </div> */}

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List New Car Final"
              data={newCar}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default NewCarFinal;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/NewCar/Final/NewCar.js